export default "__VITE_ASSET__CygLL$AH__"